export default {
  LOAD_EVENT (state, payload) {
    state.eventObject = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/event/vuex/mutations.js